var _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: "100%",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H32V32H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    y: 6,
    fill: "#0E9347",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3BB54A",
    fillRule: "evenodd",
    d: "M4.533 24.75h22.933c0-1.75 1.44-3.182 3.2-3.182V10.432c-1.76 0-3.2-1.432-3.2-3.182H4.533c0 1.75-1.44 3.182-3.2 3.182v11.136c1.76 0 3.2 1.432 3.2 3.182zm16.8-8.75c0 2.762-2.387 5-5.333 5-2.945 0-5.333-2.238-5.333-5 0-2.761 2.388-5 5.333-5 2.946 0 5.334 2.239 5.334 5zM6.667 17.25C7.403 17.25 8 16.69 8 16s-.597-1.25-1.334-1.25c-.736 0-1.333.56-1.333 1.25s.597 1.25 1.333 1.25zm20-1.25c0 .69-.596 1.25-1.333 1.25-.736 0-1.333-.56-1.333-1.25s.597-1.25 1.333-1.25c.737 0 1.334.56 1.334 1.25z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.d0e5fdc7ea1dbd4c93b28bcb5f0de7e1.svg";
export { ForwardRef as ReactComponent };